import reframe from 'reframe.js'

class Single {
  constructor() {
    // responsive iframe embeds
    reframe('.entry-content.no-blocks iframe')
  }
}

export default Single
